import { useEffect, useState } from "react";
import { apiFetch } from "../utils/api";

export default function UserList({ user, refreshKey}) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tempPasswordInfo, setTempPasswordInfo] = useState(null); // shape: { username, password }
  const [tempPasswords, setTempPasswords] = useState({});
  
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("Password copied to clipboard");
    } catch {
      alert("Failed to copy password");
    }
  };

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await apiFetch("/admin/users", {
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      });

  const data = await res.json();
  setUsers(data);

      } catch (err) {
        console.error(err);
        setError("Failed to load users");
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
    fetchUsers();
  }, [refreshKey]);


  const updateRole = async (userId, role) => {
    try {
      await apiFetch(`/admin/users/${userId}/role`, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${user.token}`
        },
        body: JSON.stringify({ role })
      });
      fetchUsers();
    } catch {
      alert("Failed to update role");
    }
  };

  const resetPassword = async (userId) => {
    try {
      const res = await apiFetch(
        `/admin/users/${userId}/reset-password`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        }
      );

      const data = await res.json();

      setTempPasswords(prev => ({
        ...prev,
        [userId]: data.tempPassword
      }));
    } catch (err) {
      console.error(err);
      alert("Failed to reset password");
    }
  };

  if (loading) return <p>Loading users...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div style={{ marginTop: "2rem" }}>
      <h3>User Management</h3>

      <table>
        <thead>
          <tr>
            <th>Username</th>
            <th>Role</th>
            <th>First Login?</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {tempPasswordInfo && (
            <div className="temp-password-box">
              <p>
                <strong>Temporary password for {tempPasswordInfo.username}:</strong>
              </p>

              <code className="temp-password">
                {tempPasswordInfo.password}
              </code>

              <button
                onClick={() => {
                  navigator.clipboard.writeText(tempPasswordInfo.password);
                  alert("Password copied to clipboard");
                }}
              >
                Copy to Clipboard
              </button>

              <button
                className="secondary-btn"
                onClick={() => setTempPasswordInfo(null)}
              >
                Dismiss
              </button>
            </div>
          )}
          {users.map(u => (
            <tr key={u.id}>
              <td>{u.username}</td>
              <td>
                <select
                  value={u.role}
                  onChange={e => updateRole(u.id, e.target.value)}
                  disabled={u.id === user.id}
                >
                  <option value="admin">admin</option>
                  <option value="superadmin">superadmin</option>
                </select>
              </td>
              <td>{u.isFirstLogin ? "Yes" : "No"}</td>
              <td>
                <button
                  onClick={() => resetPassword(u.id)}
                  disabled={u.id === user.id}
                >
                  Reset Password
                </button>
                {tempPasswords[u.id] && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <code>{tempPasswords[u.id]}</code>
                    <button
                      type="button"
                      onClick={() => copyToClipboard(tempPasswords[u.id])}
                      style={{ marginLeft: "0.5rem" }}
                    >
                      Copy
                    </button>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
